import { Box, Text } from '@jfs/ui-new'
import { observer } from 'mobx-react'
import { FC, ReactElement } from 'react'
import { TableComponent } from '../../../comps/TableComponent'
import { MerchantType } from '../../../data/models/Merchant'
import { useStores } from '../../../data/store'
import { useWindowDimensions } from '../../../util/util'
import { styles } from './../styles'

interface BusinessProps {
  hide?: boolean
  data: MerchantType
}

const buzzData = (
  mid: string,
  buzzName: string,
  webAddr: string,
  yearsOfBuzz: string,
  authorizedSign: string,
  vpa: string,
) => {
  return [
    { id: '1', title: 'MID', value: mid },
    { id: '2', title: 'Business Name', value: buzzName ?? '' },
    { id: '3', title: 'UPI Handle', value: vpa ?? '' },
    { id: '4', title: 'Web Address', value: webAddr },
    { id: '5', title: 'Years of Business', value: yearsOfBuzz },
    { id: '6', title: 'Authorized Signatory', value: authorizedSign },
  ]
}

// const kycData = () => {
//   return [
//     {
//       id: '1',
//       title: 'Proof of Identity(POI)',
//       value: '',
//     },
//     {
//       id: '2',
//       title: 'Proof of Address(POA)',
//       value: '',
//     },
//     { id: '3', title: 'Bussiness Proof', value: '' },
//     {
//       id: '4',
//       title: 'Photo',
//       value: '',
//     },
//   ]
// }

const Business: FC<BusinessProps> = ({ hide, data }: BusinessProps) => {
  const { selectedMerchantId, merchantName } = useStores((store) => ({
    selectedMerchantId: store?.user?.selectedMid,
    merchantName: store?.settings?.metaData?.selectedMercName,
  }))

  const viewPortWidth = useWindowDimensions()

  const themedStyle = styles(viewPortWidth)

  if (hide) {
    return null
  }

  const getSeperator = (): ReactElement => {
    return <Box {...themedStyle.separatorStyle} />
  }

  const getHeader = (header: string): ReactElement => {
    return (
      <>
        <Box {...themedStyle.headerStyle}>
          <Text {...themedStyle.headerTextStyle}>{header}</Text>
        </Box>
        <Box {...themedStyle.separatorStyle} />
      </>
    )
  }

  const renderListItem = ({ item }: any): ReactElement => {
    return (
      <Box {...themedStyle.listItemContainer}>
        <Text {...themedStyle.listItemKeyStyle} testID="key">
          {item?.title}
        </Text>
        <Text {...themedStyle.listItemValueStyle} testID={`personalTabView-${item?.title?.replaceAll(' ', '')}`}>
          {item?.value}
        </Text>
      </Box>
    )
  }

  return (
    <Box testID={'businessTabView'} {...themedStyle.personalDataContainer}>
      <TableComponent
        value={''} //Routes value
        canFetchMore={false}
        ListContent={buzzData(
          selectedMerchantId,
          merchantName,
          data?.contact?.website ?? '',
          data?.age,
          data?.authorisedSignatory,
          data?.vpa,
        )}
        hide={false}
        isCustom={true}
        RenderCustomElement={renderListItem}
        ItemSeparatorComponent={getSeperator}
        keyExtractor={(item) => item.id}
        ListHeaderComponent={getHeader('Business Details')}
      />
    </Box>
  )
}
export default observer(Business)
